// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__Aybpt","emails":"CreateEditClinics_emails__2L9od","emailTagLabel":"CreateEditClinics_emailTagLabel__37cYx"};